import { mergeProps } from '@zag-js/solid';
import { createSplitProps } from '../../utils/create-split-props';
import { ark } from '../factory';
import { datePickerAnatomy } from './date-picker.anatomy';
import { useDatePickerContext } from './use-date-picker-context';
import { DatePickerViewProvider } from './use-date-picker-view-props-context';
export const DatePickerView = (props) => {
    const [viewProps, localProps] = createSplitProps()(props, ['view']);
    const api = useDatePickerContext();
    const mergedProps = mergeProps(() => datePickerAnatomy.build().view.attrs, localProps);
    return (<DatePickerViewProvider value={viewProps}>
      <ark.div {...mergedProps} hidden={api().view !== viewProps.view}/>
    </DatePickerViewProvider>);
};
